/**
 * Synchronously detect whether the page was just loaded as the landing of a
 * `signInWithRedirect()` round-trip.
 *
 * The Firebase JS SDK records pending redirect state in sessionStorage under
 * keys prefixed with `firebase:` (notably `firebase:redirectEvent:` and
 * `firebase:pendingRedirect:`); the SDK clears them once `getRedirectResult()`
 * consumes the result.
 *
 * Reading synchronously on first render lets pages skip the form and show a
 * "Completing sign-in" loader during the ~1-2s window before getRedirectResult
 * resolves and we navigate the user to their portal — otherwise the user sees
 * the form flash and may click before the navigation fires.
 */
export function isReturningFromFirebaseRedirect(): boolean {
  if (typeof window === 'undefined') return false;
  try {
    for (let i = 0; i < window.sessionStorage.length; i++) {
      const key = window.sessionStorage.key(i);
      if (key?.startsWith('firebase:redirectEvent:') || key?.startsWith('firebase:pendingRedirect:')) {
        return true;
      }
    }
  } catch {
    // SecurityError when sessionStorage is disabled (e.g. cookies blocked).
    // No way to detect a pending redirect in that case — fall through to the
    // form, which is the safer default.
  }
  return false;
}
